import { Label as Container } from './styles'

export function StepsText({ step }) {
  return <Container>{step.title}</Container>
}
